 <template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Lista Operazioni </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-select
        :items="[
          { name: 'Completo' },
          { name: 'Bottoni' },
          { name: 'Informazioni' },
        ]"
        class="mt-6"
        item-text="name"
        label="Scegli cosa visualizzare"
        dense
        outlined
        solo
        style="display: inline-block; max-width: 200px"
        v-model="select_header"
        @change="changeHeader"
      ></v-select>
      <v-spacer></v-spacer>

      <!-- Bottone della legenda -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="showInformation"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-information-outline </v-icon>
          </v-btn>
        </template>
        <span>Legenda</span>
      </v-tooltip>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="addOperazione" small v-bind="attrs" v-on="on">
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi</span>
      </v-tooltip>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-5"
            @click="setOperazioni"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone per tornare indietro -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table
      :headers="headers_operazioni"
      :items="items_operazioni.filter((o) => o.validita != 0)"
      :key="key_tabella"
      :items-per-page="5"
    >
      <!-- <template v-slot:[`item.query`]="{ item }">
        <v-btn small @click="clickApriDialogQuery(item)">
          <v-icon color="primary"> mdi-database </v-icon>
        </v-btn>
      </template> -->

      <!-- <template v-slot:[`item.elimina`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickDeleteOperazione(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Cancella</span>
        </v-tooltip>
      </template> -->

      <template v-slot:item="{ item }">
        <tr>
          <td
            v-for="(col, columnIndex) in headers_operazioni"
            :key="columnIndex"
          >
            <div v-if="columnIndex == 0">
              <v-btn @click="modificaOperazione(item)" small>
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </div>
            <div v-if="columnIndex == 4">
              <v-btn small @click="clickApriDialogQuery(item)">
                <v-icon color="primary"> mdi-database </v-icon>
              </v-btn>
            </div>
            <div v-if="columnIndex == headers_operazioni.length - 1">
              <v-btn @click="clickDeleteOperazione(item)" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </div>
            <div
              v-if="
                columnIndex > 4 && columnIndex < headers_operazioni.length - 1
              "
            >
              <!-- Icona del flag check (abilitazione) -->
              <v-tooltip bottom v-if="item[col.value] == 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="switchAutorizzazione(item, col.value)"
                    color="success"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-check-underline
                  </v-icon>
                </template>
                <span>1 abilita, 0 disabilita</span>
              </v-tooltip>

              <!-- Icona del flag croce (abilitazione) -->
              <v-tooltip bottom v-else-if="item[col.value] == 2">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="switchAutorizzazione(item, col.value)"
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close
                  </v-icon>
                </template>
                <span>0 abilita, 1 disabilita</span>
              </v-tooltip>

              <!-- Icona dello stato non assegnato (abilitazione) -->
              <v-icon
                v-else
                @click="switchAutorizzazione(item, col.value)"
                color="blue-grey lighten-4"
              >
                mdi-minus
              </v-icon>

              <!-- Icona dell'occhio verde (visibilità) -->
              <v-tooltip bottom v-if="item[col.value + '_VISIBLE'] == 1 && item[col.value] != 0">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="switchVisibilita(item, col.value + '_VISIBLE')"
                    color="success"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>1 visibile, 0 invisibile</span>
              </v-tooltip>

              <!-- Icona dell'occhio rosso (visibilità) -->
              <v-tooltip bottom v-else-if="item[col.value + '_VISIBLE'] == 0 && item[col.value] != 0">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="switchVisibilita(item, col.value + '_VISIBLE')"
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>0 visibile, 1 invisibile</span>
              </v-tooltip>
            </div>
            <div
              :style="{
                textAlign: columnIndex === 0 ? 'center' : 'left',
              }"
              v-else-if="columnIndex != 4"
            >
              {{ item[col.value] }}
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="conferma_elimina_operazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler cancellare l'operazione selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_elimina_operazione = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="deleteOperazione" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-overlay :value="overlay_cancellazione">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="dialog_modifica" max-width="800px">
      <ModificaOperazione
        @click_chiudi="dialog_modifica = false"
        :items_btn="items_btn"
        :operazione="operazione_sel"
        :riferimento="riferimento"
        @salvata_operazione="handleSalvataOperazione"
        @get_operazioni="handleSalvataOperazione"
        @add_operation="addOperation"
        :tipo_riferimento="tipo_riferimento"
        :visible="dialog_modifica"
      />
    </v-dialog>

    <!-- DIALOG QUERY -->
    <v-dialog v-model="dialog_query" max-width="800px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Editor Query </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaQuery" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickChiudiDialogQuery"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <QueryEditor v-model="query_sel" :template="[]" :key="key" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog della legenda delle variabili -->
    <v-dialog v-model="dialog_info" max-width="800px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Legenda </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_info = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container
            style="color: black; font-size: 15px"
            class="pl-10 mt-5"
            fluid
          >
            <v-row align="center" class="mt-5" justify="center">
              <v-col class="my-0 py-0" align="left" justify="center" cols="12">
                <span style="color: black; font-size: 18px">
                  Sono elencate di seguito le variabili utilizzabili nelle query
                  delle operazioni:
                </span>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-5" justify="center">
              <v-col class="my-0 py-0" align="left" justify="center" cols="12">
                @id_commessa_dettaglio
              </v-col>
            </v-row>
            <v-row align="center" class="mt-5" justify="center">
              <v-col class="my-0 py-0" align="left" justify="center" cols="12">
                @id_commessa
              </v-col>
            </v-row>
            <v-row align="center" class="mt-5" justify="center">
              <v-col class="my-0 py-0" align="left" justify="center" cols="12">
                @id_personale
              </v-col>
            </v-row>
            <v-row align="center" class="mt-5" justify="center">
              <v-col class="my-0 py-0" align="left" justify="center" cols="12">
                @id_articolo_packaging
              </v-col>
            </v-row>
            <v-row align="center" class="mt-5" justify="center">
              <v-col class="my-0 py-0" align="left" justify="center" cols="12">
                @id_articolo
              </v-col>
            </v-row>
            <v-row align="center" class="mt-5" justify="center">
              <v-col class="my-0 py-0" align="left" justify="center" cols="12">
                @controllo
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import ModificaOperazione from "@/components/OPERAZIONI/ModificaOperazione.vue";
// import moment from "moment/moment";
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

// class Operazione {
//   constructor(arg = undefined) {
//     if (arg != undefined) {
//       const campi = this.setCampi();
//       campi.forEach((c) => {
//         this[c.nome] =
//           arg[c.nome] != undefined
//             ? c.complex === false
//               ? arg[c.nome]
//               : JSON.parse(JSON.stringify(arg[c.nome]))
//             : c.default_val;
//       });
//     } else {
//       const campi = this.setCampi();
//       campi.forEach((c) => {
//         this[c.nome] = c.default_val;
//       });
//     }
//   }

//   // Metodo per resettare tutte le campi
//   reset() {
//     const campi = this.setCampi();

//     campi.forEach((c) => {
//       this[c.nome] = c.default_val;
//     });
//   }

//   setCampi() {
//     const campi = [
//       { nome: "abilitazione", default_val: 0, complex: false },
//       { nome: "cod_operazione", default_val: "", complex: false },
//       { nome: "des_operazione", default_val: "", complex: false },
//       { nome: "des_tipo", default_val: "", complex: false },
//       { nome: "id_operazione", default_val: -1, complex: false },
//       {
//         nome: "id_operazione_tmp",
//         default_val: -moment().valueOf(),
//         complex: false,
//       },
//       { nome: "id_operazione_abilitazione", default_val: -1, complex: false },
//       { nome: "wo_visibile", default_val: 1, complex: false },
//       // { nome: "pulsanti", default_val: [], complex: true },
//       // { nome: "ST-ST", default_val: 0, complex: false },
//       // { nome: "AVPACK", default_val: 0, complex: false },
//       // { nome: "SUBENTRO", default_val: 0, complex: false },
//       // { nome: "REGPZ", default_val: 0, complex: false },
//       // { nome: "VDIS", default_val: 0, complex: false },
//       // { nome: "LOTTI", default_val: 0, complex: false },
//       // { nome: "CONTROLLO", default_val: 0, complex: false },
//       // { nome: "FASENOTE", default_val: 0, complex: false },
//       // { nome: "SPACK", default_val: 0, complex: false },
//       // { nome: "COMNOTE", default_val: 0, complex: false },
//       // { nome: "CQUALITA", default_val: 0, complex: false },
//       // { nome: "ALLEGATO", default_val: 0, complex: false },
//       // { nome: "ISTR", default_val: 0, complex: false },
//       // { nome: "AMWO", default_val: 0, complex: false },
//       // { nome: "NWO", default_val: 0, complex: false },
//       // { nome: "LISTA", default_val: 0, complex: false },
//       // { nome: "REGALT", default_val: 0, complex: false },
//       // { nome: "LAVTEAM", default_val: 0, complex: false },
//       // { nome: "IPP", default_val: 0, complex: false },
//       // { nome: "PRTETICH", default_val: 0, complex: false },
//       // { nome: "REGIMB", default_val: 0, complex: false },
//       // { nome: "CHECK", default_val: 0, complex: false },
//       // { nome: "VBAS", default_val: 0, complex: false },
//       // { nome: "RILTMP", default_val: 0, complex: false },
//       // { nome: "DICSCARTI", default_val: 0, complex: false },
//       // { nome: "SIGNAL", default_val: 0, complex: false },
//       // { nome: "XXXX", default_val: 0, complex: false },

//       { nome: "query", default_val: "", complex: false },
//       { nome: "riferimento", default_val: null, complex: false },
//       { nome: "tipo_operazione", default_val: null, complex: false },
//       { nome: "tipo_riferimento", default_val: "", complex: false },
//       { nome: "validita", default_val: 1, complex: false },
//     ];

//     return campi;
//   }
// }

export default {
  name: "AggiungiOperazione",
  components: {
    ModificaOperazione,
    QueryEditor,
    SnackbarQV,
  },
  props: {
    riferimento: { type: Number, default: null },
    tipo_riferimento: { type: String, default: "" },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      // Variabili d'appoggio
      colonna_eliminazione: {
        text: "Elimina",
        value: "elimina",
        sortable: false,
      },
      operazione_sel: {},
      // operazione_sel: new Operazione(),
      query_sel: {
        query: "",
      },
      row_sel: {},
      select_header: "Completo",

      // Modal
      conferma_elimina_operazione: false,
      dialog_info: false,
      dialog_modifica: false,
      dialog_query: false,
      key: 0,
      key_tabella: 0,
      overlay: false,
      overlay_cancellazione: false,

      // Array
      headers_fissi: [
        { text: "Modifica", value: "", sortable: false },
        { text: "Cod. Operazione", value: "cod_operazione", sortable: false },
        { text: "Des. Operazione", value: "des_operazione", sortable: false },
        {
          text: "Tipo Operazione",
          value: "des_tipo",
          sortable: false,
        },
        { text: "Query", value: "query", sortable: false },
        /*{ text: "WO Visibile", value: "wo_visibile", sortable: false },*/
      ],
      headers_operazioni: [],
      headers_operazioni_btn: [],
      headers_operazioni_info: [],
      // headers_operazioni: [
      //   { text: "Seleziona", value: "abilitazione", sortable: false },
      //   { text: "Modifica", value: "modifica", sortable: false },
      //   { text: "Cod. Operazione", value: "cod_operazione", sortable: false },
      //   { text: "Des. Operazione", value: "des_operazione", sortable: false },
      //   { text: "Pulsanti", value: "pulsanti", sortable: false },
      //   {
      //     text: "Tipo Operazione",
      //     value: "des_tipo",
      //     sortable: false,
      //   },
      //   { text: "Elimina", value: "elimina", sortable: false },
      // ],
      items_btn: new Array(),
      items_operazioni: new Array(),
    };
  },
  computed: {},
  watch: {
    // visible: {
    //   immediate: true,
    //   async handler() {
    //     if (this.visible === true) {
    //       await this.getOperazioni();
    //       await this.getPulsantiHeader();
    //       this.getOperazioniAbilitazioni();
    //     }
    //   },
    // },
  },
  methods: {
    addOperation(arg) {
      console.log("arg from emit", arg);

      if (arg.id_operazione == -1) {
        let ricorre = 0;
        this.items_operazioni.forEach((e) => {
          if (e.id_operazione_tmp == arg.id_operazione_tmp) {
            e.cod_operazione = arg.cod_operazione;
            e.des_operazione = arg.des_operazione;
            e.des_tipo = arg.des_tipo;
            ricorre++;
            console.log(
              "operazione appena creata e modificata",
              e,
              arg,
              ricorre
            );
          }
        });
        if (ricorre == 0) {
          console.log("operazionecreata e aggiunta", arg);
          this.items_operazioni.push(arg);
        }
      } else {
        this.items_operazioni.forEach((e) => {
          if (e.id_operazione == arg.id_operazione) {
            e.cod_operazione = arg.cod_operazione;
            e.des_operazione = arg.des_operazione;
            e.des_tipo = arg.des_tipo;
            console.log("operazione esistente modificata", e, arg);
          }
        });
      }

      this.key_tabella = this.key_tabella === 0 ? 1 : 0;
      console.log("array operazioni =>", this.items_operazioni);
      this.dialog_modifica = false;
    },
    addOperazione() {
      console.log(
        "riferimento e tipo riferimento",
        this.riferimento,
        this.tipo_riferimento
      );
      // this.operazione_sel = new Operazione();
      this.operazione_sel = {};
      this.operazione_sel.riferimento = this.riferimento;
      this.operazione_sel.tipo_riferimento = this.tipo_riferimento;

      this.dialog_modifica = true;
    },
    clickApriDialogQuery(item) {
      this.row_sel = item;
      this.query_sel.query = item.query != null ? item.query : "";
      this.dialog_query = true;
      this.key = this.key == 1 ? 0 : 1;
      console.log("click apri query => ", item, this.query_sel);
    },
    clickChiudiDialogQuery() {
      this.dialog_query = false;
      this.key = this.key == 1 ? 0 : 1;
      this.query_sel = {
        query: "",
      };
    },
    clickDeleteOperazione(arg) {
      // this.operazione_sel = new Operazione(arg);
      this.operazione_sel = arg;
      this.conferma_elimina_operazione = true;
    },
    clickIndietro() {
      this.$emit("click_indietro");
    },
    changeHeader() {
      if (this.select_header == "Bottoni") {
        console.log("Bottoni");
        this.headers_operazioni = this.headers_fissi;
        this.headers_operazioni = this.headers_operazioni.concat(
          this.headers_operazioni_btn
        );
        this.headers_operazioni.push(this.colonna_eliminazione);
      } else if (this.select_header == "Informazioni") {
        console.log("Informazioni");
        this.headers_operazioni = this.headers_fissi;
        this.headers_operazioni = this.headers_operazioni.concat(
          this.headers_operazioni_info
        );
        this.headers_operazioni.push(this.colonna_eliminazione);
      } else {
        console.log("Completo");
        this.headers_operazioni = this.headers_fissi;
        this.headers_operazioni = this.headers_operazioni.concat(
          this.headers_operazioni_btn.concat(this.headers_operazioni_info)
        );
        this.headers_operazioni.push(this.colonna_eliminazione);
      }
    },
    deleteOperazione() {
      /* Se l'operazione era nuova enon l'ho ancora salvata la metto
       * non valida e la data table smetterà automaticamente di mostrarla. */
      if (this.operazione_sel.id_operazione < 0) {
        for (let o = 0; o < this.items_operazioni.length; o++) {
          if (
            this.items_operazioni[o].id_operazione ==
            this.operazione_sel.id_operazione
          ) {
            this.$set(this.items_operazioni[o], "validita", 0);
          }
        }

        this.conferma_elimina_operazione = false;
      } else {
        // Se invece l'operazione esisteva la cancello con una chiamata al BE.
        this.executeCallDeleteOperazione();
      }
    },
    editOperazione(arg) {
      this.operazione_sel = arg;
      // this.operazione_sel = new Operazione(arg);
      this.dialog_modifica = true;
    },
    executeCallDeleteOperazione() {
      const obj_tmp = this.operazione_sel;
      // const obj_tmp = new Operazione(this.operazione_sel);
      obj_tmp.validita = 0;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setoperazionifull",
          token: localStorage.user_token,
          operazioni_abilitazioni: [obj_tmp],
        },
      };

      this.overlay_cancellazione = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_cancellazione = false;
          if (res.status === 200) {
            this.conferma_elimina_operazione = false;
            this.getOperazioniFull();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i fati."
            );
          }
        })
        .catch((e) => {
          this.overlay_cancellazione = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i fati."
          );
        });
    },
    getOperazioniFull() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getoperazionifull",
          token: localStorage.user_token,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            console.log("res", res);
            this.items_operazioni = new Array();
            res.data.result.operazioni.forEach((o) => {
              const obj_tmp = o;
              // const obj_tmp = new Operazione(o);
              obj_tmp.riferimento = this.riferimento;
              obj_tmp.tipo_riferimento = this.tipo_riferimento;

              this.items_operazioni.push(obj_tmp);
            });
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    // getOperazioni() {
    //   const request = {
    //     controller: "Magazzino",
    //     method: "POST",
    //     richiesta: {
    //       action: "getoperazioni",
    //       token: localStorage.user_token,
    //     },
    //   };

    //   this.overlay = true;
    //   return this.$store
    //     .dispatch("api", request)
    //     .then((res) => {
    //       this.overlay = false;
    //       if (res.status === 200) {
    //         this.items_operazioni = new Array();
    //         res.data.result.operazioni.forEach((o) => {
    //           const obj_tmp = new Operazione(o);
    //           obj_tmp.riferimento = this.riferimento;
    //           obj_tmp.tipo_riferimento = this.tipo_riferimento;

    //           this.items_operazioni.push(obj_tmp);
    //         });
    //         return true;
    //       } else {
    //         this.$refs.SnackbarQV.print(
    //           "orange",
    //           "Errore di comunicazione col server, non è stato possibile caricare i dati."
    //         );
    //         return false;
    //       }
    //     })
    //     .catch((e) => {
    //       this.overlay = false;
    //       console.error(e);
    //       this.$refs.SnackbarQV.print(
    //         "error",
    //         "Errore di comunicazione col server, non è stato possibile caricare i dati."
    //       );
    //       return false;
    //     });
    // },
    // getOperazioniAbilitazioni() {
    //   const request = {
    //     controller: "Magazzino",
    //     method: "POST",
    //     richiesta: {
    //       action: "getoperazioniabilitazioni",
    //       token: localStorage.user_token,
    //       riferimento: this.riferimento,
    //       tipo_riferimento: this.tipo_riferimento,
    //     },
    //   };

    //   this.overlay = true;

    //   this.$store
    //     .dispatch("api", request)
    //     .then((res) => {
    //       this.overlay = false;
    //       if (res.status === 200) {
    //         res.data.result.autorizzazioni.forEach((a) => {
    //           this.items_operazioni.forEach((o) => {
    //             if (o.id_operazione === a.id_operazione) {
    //               o.id_operazione_abilitazione = a.id_operazione_abilitazione;
    //               o.pulsanti.push({
    //                 fields: a.fields,
    //                 des:
    //                   this.items_btn.filter((p) => p.fields === a.fields)
    //                     .length > 0
    //                     ? this.items_btn.filter((p) => p.fields === a.fields)[0]
    //                         .tooltip
    //                     : "",
    //               });
    //               o.abilitazione = 1;
    //             }
    //           });
    //         });
    //       } else {
    //         this.$refs.SnackbarQV.print(
    //           "orange",
    //           "Errore di comunicazione col server, non è stato possibile caricare i dati."
    //         );
    //       }
    //     })
    //     .catch((e) => {
    //       this.overlay = false;
    //       console.error(e);
    //       this.$refs.SnackbarQV.print(
    //         "error",
    //         "Errore di comunicazione col server, non è stato possibile caricare i dati."
    //       );
    //     });
    // },
    getPulsantiHeader() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          nome_modulo: "AVANZAMENTO",
          id_profilo: "",
        },
      };

      this.overlay = true;

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            // ... Preparo l'array dei bottoni...
            const arr_btn_tmp = new Array();
            this.headers_operazioni = new Array();

            // ... Popolo il mio array...
            if (res.data.length != 0) {
              // let arr_fields = [];
              this.headers_operazioni = this.headers_fissi;

              res.data.forEach((e) => {
                if (e.tipo_oggetto === "B") {
                  const obj_tmp = new Object();
                  obj_tmp.id_header = e.id_header;
                  obj_tmp.fields = e.fields;
                  obj_tmp.tooltip = e.tooltip;
                  arr_btn_tmp.push(obj_tmp);

                  const obj_header = {
                    text: e.text,
                    value: e.fields,
                  };

                  this.headers_operazioni_btn.push(obj_header);

                  // const obj_field = {
                  //   icon: e.icona,
                  //   value: e.fields,
                  // };

                  // arr_fields.push(obj_field);
                }
                if (e.tipo_oggetto === "D" || e.tipo_oggetto === "N") {
                  const obj_tmp = new Object();
                  obj_tmp.id_header = e.id_header;
                  obj_tmp.fields = e.fields;
                  obj_tmp.tooltip = e.tooltip;
                  arr_btn_tmp.push(obj_tmp);

                  const obj_header = {
                    text: e.text,
                    value: e.fields,
                  };

                  this.headers_operazioni_info.push(obj_header);
                }
              });

              this.headers_operazioni = this.headers_operazioni.concat(
                this.headers_operazioni_btn.concat(this.headers_operazioni_info)
              );

              // arr_fields.forEach((e) => {
              //   console.log("e ==>", e, this.items_operazioni);

              //   this.items_operazioni.forEach((o) => {
              //     Object.keys(e).forEach((n) => {
              //       if (e[n] == "icon") {
              //         o[n] = e[n];
              //       } else {
              //         o[e[n]] = 0;
              //       }
              //       console.log("o ==> ", o);
              //     });
              //   });
              // });
              this.headers_operazioni.push(this.colonna_eliminazione);
            }

            // ... E li registro nelle variabili di supporto del componente.
            this.items_btn = arr_btn_tmp;
            this.overlay = false;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            this.overlay = false;
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          this.overlay = false;
          return false;
        });
    },
    async handleSalvataOperazione() {
      this.dialog_modifica = false;

      await this.getOperazioniFull();
      // this.getOperazioniAbilitazioni();
    },
    modificaOperazione(item) {
      this.dialog_modifica = true;
      this.operazione_sel = item;
    },
    onOffBtn(item) {
      console.log(item);
    },
    printTooltips(arg_arr) {
      let res = "";
      arg_arr.forEach((e) => (res += e.tooltip + ", "));
      if (res.length > 0) {
        res = res.substring(0, res.length - 2);
      }
      return res;
    },
    selectOperazione(arg) {
      this.$set(arg, "abilitazione", arg.abilitazione == 1 ? 0 : 1);
    },
    setOperazioni() {
      // Metto da parte le operazioni vecchie e quelle nuove e valide.
      const arr_tmp = JSON.parse(
        JSON.stringify(
          this.items_operazioni.filter(
            (o) => o.validita != 0 || o.id_operazione > 0
          )
        )
      );

      // Metto a -1 l'identificativo delle operazioni nuove.
      arr_tmp.forEach((o) => {
        if (o.id_operazione < 0) {
          o.id_operazione = -1;
        }
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setoperazionifull",
          token: localStorage.user_token,
          operazioni_abilitazioni: arr_tmp,
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Operazioni aggiornate con successo."
            );
            await this.getOperazioniFull();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i fati."
          );
        });
    },
    // setOperazioni() {
    //   // Metto da parte le operazioni vecchie e quelle nuove e valide.
    //   const arr_tmp = JSON.parse(
    //     JSON.stringify(
    //       this.items_operazioni.filter(
    //         (o) => o.validita != 0 || o.id_operazione > 0
    //       )
    //     )
    //   );

    //   // Metto a -1 l'identificativo delle operazioni nuove.
    //   arr_tmp.forEach((o) => {
    //     if (o.id_operaizone < 0) {
    //       o.id_operazione = -1;
    //     }
    //   });

    //   const request = {
    //     controller: "Magazzino",
    //     method: "PUT",
    //     richiesta: {
    //       action: "setoperazioniabilitazioni",
    //       token: localStorage.user_token,
    //       tabella: arr_tmp,
    //     },
    //   };

    //   this.overlay = true;

    //   this.$store
    //     .dispatch("api", request)
    //     .then(async (res) => {
    //       this.overlay = false;
    //       if (res.status === 200) {
    //         await this.getOperazioniFull();
    //         // this.getOperazioniAbilitazioni();
    //       } else {
    //         this.$refs.SnackbarQV.print(
    //           "orange",
    //           "Errore di comunicazione col server, non è stato possibile salvare i fati."
    //         );
    //       }
    //     })
    //     .catch((e) => {
    //       this.overlay = false;
    //       console.error(e);
    //       this.$refs.SnackbarQV.print(
    //         "error",
    //         "Errore di comunicazione col server, non è stato possibile salvare i fati."
    //       );
    //     });
    // },
    salvaQuery() {
      this.items_operazioni.forEach((o) => {
        if (o.id_operazione == this.row_sel.id_operazione) {
          o.query = this.query_sel.query;
        }
      });
      console.log("nw query =>", this.query_sel);
      this.dialog_query = false;
    },
    showInformation() {
      this.dialog_info = true;
    },
    switchAutorizzazione(arg, val) {
      if (arg[val] == 0) {
        arg[val] = 1;
      } else if (arg[val] == 1) {
        arg[val] = 2;
      } else if (arg[val] == 2) {
        arg[val] = 0;
      }
    },
    switchVisibilita(arg, val) {
      if (arg[val] == 0) {
        arg[val] = 1;
      } else {
        arg[val] = 0;
      }
    },
  },
  created() {},
  mounted() {
    this.getOperazioniFull();
    this.getPulsantiHeader();
  },
};
</script>
<style scoped>
</style>

